import { useKeycloak } from "@react-keycloak/web";
import { Route } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import LoginPage from "../LoginPage";
import tailwindClassnames from "./TailwindClassnames";

interface PrivateRouteProps {
  path: string; // Define any props you need for routing
  element: React.ReactElement;
}

const ProtectedRoute: React.FC<PrivateRouteProps> = ({ element, ...rest }) => {
  const { keycloak, initialized } = useKeycloak();

  const getElement = () => {
    // Show loading until keycloak is initialized
    if (!initialized) {
      return (
        <div className="sweet-loading flex justify-center w-full">
          <BeatLoader
            color={tailwindClassnames.skyBlueDark}
            loading={true}
            size={15}
            margin={5}
          />
        </div>
      );
    }

    return keycloak.authenticated ? element : <LoginPage />;
  };

  return <Route {...rest} element={getElement()} />;
};

export default ProtectedRoute;
